import Cookies from 'js-cookie';

/** 제안용 체험 로그인 아이디. 서버 가입이나 매장 연결 없이 이 아이디로 로그인하면 체험 화면이 열린다. */
const BUILTIN_DEMO_LOGIN_IDS = ['kisdemo'];

const EXTRA_DEMO_LOGIN_IDS = (process.env.REACT_APP_DEMO_LOGIN_IDS || '')
  .split(',')
  .map((id) => id.trim().toLowerCase())
  .filter(Boolean);

export const DEMO_LOGIN_IDS = Array.from(
  new Set([...BUILTIN_DEMO_LOGIN_IDS, ...EXTRA_DEMO_LOGIN_IDS]),
);

const DEMO_COOKIE = 'smartlab_demo';
const TOUR_STATE_KEY = 'smartlab_owner_tour';
const DEMO_AUTHORITY = 'ROLE_MANAGER';

export const isDemoLoginId = (loginId: string | undefined | null) => {
  const value = (loginId || '').trim().toLowerCase();
  return value.length > 0 && DEMO_LOGIN_IDS.includes(value);
};

export const isDemoSession = () =>
  Cookies.get(DEMO_COOKIE) === '1' && Cookies.get('smartlab_authority') !== 'ROLE_MASTER';

/** 서버 계정 없이 체험 화면만 연다. */
export const startDemoSession = () => {
  Cookies.set(DEMO_COOKIE, '1', { path: '/' });
  Cookies.set('smartlab_authority', DEMO_AUTHORITY, { path: '/' });
  sessionStorage.removeItem(TOUR_STATE_KEY);
};

export const clearDemoSession = () => {
  const wasDemo = Cookies.get(DEMO_COOKIE) === '1';
  Cookies.remove(DEMO_COOKIE, { path: '/' });
  sessionStorage.removeItem(TOUR_STATE_KEY);
  if (wasDemo) {
    Cookies.remove('smartlab_authority', { path: '/' });
  }
};

export { DEMO_AUTHORITY };

export const readTourState = () => sessionStorage.getItem(TOUR_STATE_KEY);

export const writeTourState = (value: string) => {
  sessionStorage.setItem(TOUR_STATE_KEY, value);
};
